export const BASE_URL = `${window.location.protocol}//${
  window.location.hostname
}`;
export const API_URL = BASE_URL + '/api';